const header = {
  elem: null,
  scrollPos: 0,
  scrollInit: 100,
  scrollNotify: 0,
};

function hasNotify() {
  const notify = document.querySelector('.notification');

  if (notify) {
    header.scrollNotify = notify.clientHeight;
  }
}

function scroller() {
  const scrollTop = window.scrollY;

  if (scrollTop > header.scrollPos && scrollTop > header.scrollInit) {
    header.elem.classList.add('has-transform');
  } else {
    header.elem.classList.remove('has-transform');
  }

  if (scrollTop > header.scrollNotify) {
    header.elem.classList.add('is-fixed');
  } else {
    header.elem.classList.remove('is-fixed');
  }

  if (scrollTop > header.scrollInit) {
    header.elem.classList.add('is-alt');
  } else {
    header.elem.classList.remove('is-alt');
  }

  header.scrollPos = scrollTop;
}

function background() {
  const hero = document.querySelector('#main > .hero');

  if (!hero) return;

  const heroBg = hero.querySelector('.hero__bg');

  if (
    (hero.classList.contains('theme--white') || hero.classList.contains('theme--light'))
    && heroBg
    && heroBg.children.length === 0
  ) {
    header.elem.classList.add('header--light');
  }
}

export default function setHeader() {
  header.elem = document.querySelector('.header');

  if (!header.elem) return;

  hasNotify();
  scroller();
  background();

  window.addEventListener('scroll', scroller);
}
